import styled from '@emotion/styled';
import { rem } from '@utils';

const GAP: Record<'sm' | 'md' | 'lg', string> = {
  sm: rem(12),
  md: rem(24),
  lg: rem(32)
};

export type GridColumns = '1' | '2' | '3' | '4';

const GRID_COLUMNS: Record<GridColumns, string> = {
  '1': 'minmax(0, 1fr)',
  '2': 'repeat(2, minmax(0, 1fr))',
  '3': 'repeat(3, minmax(0, 1fr))',
  '4': 'repeat(4, minmax(0, 1fr))'
};

const Container = styled.div`
  container: grid / inline-size;
  width: 100%;
`;

const Root = styled.div<{
  columns: GridColumns;
  gap: 'sm' | 'md' | 'lg';
  layout: 'vertical' | 'horizontal';
}>`
  display: ${({ layout }) => (layout === 'vertical' ? 'flex' : 'grid')};
  flex-direction: column;
  gap: ${({ gap }) => GAP[gap]};
  width: 100%;

  ${({ columns, layout }) =>
    layout === 'horizontal' &&
    `
    grid-template-columns: ${GRID_COLUMNS[columns]};

    @container grid (max-width: ${rem(768)}) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @container grid (max-width: ${rem(600)}) {
      grid-template-columns: minmax(0, 1fr);
    }
  `}
`;

export default {
  Container,
  Root
};
